export default {
  PAGE_LOADED: Symbol(),
  LANG_CHANGED: Symbol(),
};
